module.exports = __webpack_public_path__ + "img/renaissance_team.bee255b9.jpg";